import { useEffect, useState } from 'react'
import { AppDispatch } from '../../../../common/redux/store'
import { getSubscriptionModuleStatus } from '../redux/thunks'

type VideoCallingParams = { taasId: number } | { chainId: number }

export const useVideoCallingStatus = (params: VideoCallingParams | undefined, dispatch: AppDispatch): 'On' | 'Off' => {
  const [videoCallingStatus, setVideoCallingStatus] = useState<'On' | 'Off'>('Off')

  const id = params && ('taasId' in params ? params.taasId : params.chainId)

  useEffect(() => {
    if (!id) return

    void dispatch(getSubscriptionModuleStatus(params))
      .unwrap()
      .then((result) => {
        setVideoCallingStatus(result.enabled ? 'On' : 'Off')
      })
      .catch(() => {
        setVideoCallingStatus('Off')
      })
  }, [id, dispatch])

  return videoCallingStatus
}
